import { useMemo } from "react";
import { useAppSettingsContext } from "../../contexts/appSettingsContext";
import { useGetQueryData } from "../react-query-hooks/general";
import { fn as PublishedPage } from "./PublishedPage";

const fns = {
  PublishedPage,
};

export const useGetBreadcrumbLinksData = ({ content, comp }) => {
  const { APP_SETTINGS } = useAppSettingsContext();
  const { prevLoc } = APP_SETTINGS;
  
  const allTpls = useGetQueryData('allTpls');
  const allProfileTpls = allTpls.filter(tpl => tpl.category === 'userProfiles')

  let breadcrumbLinksData = useMemo(() => {
    if (content) {
      return fns[comp]({ content, prevLoc, allProfileTpls });
    }
  }, [content]);

  return breadcrumbLinksData;
};
